export const macrosMixin = {
  data() {
    return {
      formatMacros: (instance, type) => {
        const macros = instance.aggregatedNutritionDigest ? instance.aggregatedNutritionDigest.macroNutritionDigest : instance.macroNutritionDigest;
        if (macros[type]) {
          return {
            unit: `${macros[type].value}${macros[type].unit ? macros[type].unit : ''}`,
            percent: `${macros[type].macroPercentage}%`,
          };
        } else {
          return {
            unit: '',
            percent: '',
          };
        }
      },
    };
  },
  methods: {
    // Instance accepts either a dish
    // or a day that contains aggregatedNutritionDigest
    // or macroNutritionDigest
    formattedMacro(instance, type) {
      return this.formatMacros(instance, type);
    },
  },
};
